class PlpHeadingMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.showFilter === 'false') {
      const filtersEl = document.getElementById('main-collection-filters');
      if (filtersEl) filtersEl.style.display = 'none';
    }

    this.initSwiper();
    this.initSticky();
    this.addEventListener('open-filter-drawer', this.openFilterDrawer.bind(this));
    document.addEventListener('click', this.closeOnOutsideClick.bind(this), { capture: true });
  }

  openFilterDrawer() {
    const drawer = document.querySelector('#main-collection-filters menu-drawer');
    const summary = drawer?.querySelector('summary');
    if (!drawer || !summary) return;

    drawer.classList.remove('medium-hide', 'large-up-hide');
    summary.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
    drawer.dataset.breakpoint = 'desktop';
    this.suppressOutsideClick = true;
    summary.click();
    this.openedByThisMenu = true;
  }

  closeOnOutsideClick(event) {
    if (this.suppressOutsideClick) {
      this.suppressOutsideClick = false;
      return;
    }
    if (!this.openedByThisMenu) return;

    const drawer = document.querySelector('#main-collection-filters menu-drawer');
    const details = drawer?.querySelector('details');
    if (!details || !details.hasAttribute('open')) {
      this.openedByThisMenu = false;
      return;
    }

    const summary = details.querySelector('summary');
    const panel = details.querySelector('.mobile-facets__inner');
    const clickedInsideDrawer = summary.contains(event.target) || (panel && panel.contains(event.target));
    const clickedTriggerButton = this.contains(event.target);
    if (!clickedInsideDrawer && !clickedTriggerButton) {
      this.openedByThisMenu = false;
      summary.click();
    }
  }

  initSticky() {
    const updateOffset = () => {
      const header = document.querySelector('sticky-header, .shopify-section-header-sticky, #shopify-section-header');
      const height = header ? header.getBoundingClientRect().height : 0;
      this.style.top = `${height}px`;
    };

    updateOffset();
    window.addEventListener('resize', updateOffset);
    window.addEventListener('load', updateOffset, { once: true });
  }

  initSwiper() {
    const track = this.querySelector('.plp-heading-menu__track');
    if (!track) return;

    const activeIndex = Array.from(this.querySelectorAll('.plp-heading-menu__link')).findIndex((link) =>
      link.classList.contains('plp-heading-menu__link--active')
    );

    const updateEndState = (swiper) => {
      track.classList.toggle('is-end', swiper.isEnd || swiper.isLocked);
    };

    const start = () => {
      this.swiper = new Swiper(track, {
        slidesPerView: 'auto',
        freeMode: true,
        watchOverflow: true,
        initialSlide: activeIndex > -1 ? activeIndex : 0,
        centeredSlides: false,
        on: {
          init: updateEndState,
          resize: updateEndState,
          reachEnd: updateEndState,
          fromEdge: updateEndState,
          slideChange: updateEndState,
        },
      });
    };

    if (window.Swiper) {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }
}

customElements.define('plp-heading-menu', PlpHeadingMenu);
